import React from 'react';
import {BaseModal} from '../comun/Index';
import {Accion} from '../comun/Index';
import {
  Informado, MedioInformado,IntencionVacunarse,
  Datos, Alergia, Sospechoso, Enfermo, Aislado,
  Convive, Observaciones
} from './formularios/Index';
const pasos = require('./pasos.json');

const checkCompleto = function(datos){
  return new Promise(function(resolve, reject) {
    let completo = true;
    Object.entries(datos).forEach(async (item, i) => {
      if (Array.isArray(item[1])){
        for (var i = 0; i < item[1].length; i++) {
          completo = await checkCompleto(item[1][i]);
        }
      } else {
        if (item[1].length === 0){
          completo = false;
        }
      }
    });
    resolve(completo)
  });
}


class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      paso_id:1,
      datos:pasos.datos
    }
  }

  componentDidMount(){
    let datos = pasos.datos;
    const asignacion_id = this.props.asignacion_id;
    datos.asignacion_id = asignacion_id;
    this.setState({datos,asignacion_id})
  }

  botones(){
    return (
      [
        {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
        {titulo:"Guardar", backgroundColor:'#00a5e5', onClick: () => this.props.guardar(this.state.datos)}
      ]
    )
  }

  editar(tipo, campo, valor){
    let datos = JSON.parse(JSON.stringify(this.state.datos));
    datos[tipo][campo] = valor;
    this.setState({datos});
  }

  render(){
    const {datos} = this.state;
    return(
      <BaseModal
        titulo="Atendió"
        loading={false}
        botonera={this.botones()}
      >
        <h4 style={{textAlign:'center'}}>Complete el siguiente formulario</h4>
        <Informado
          show={true}
          editar={(campo, valor) => this.editar('Informado', campo, valor)}
          datos={datos['Informado']}
        />
        <MedioInformado
          show={true}
          editar={(campo, valor) => this.editar('Medio información', campo, valor)}
          datos={datos['Medio información']}
        />
        <IntencionVacunarse
          show={true}
          editar={(campo, valor) => this.editar('Intención de vacunación', campo, valor)}
          datos={datos['Intención de vacunación']}
        />
        <Datos
          show={datos['Intención de vacunación'].intencion}
          editar={(campo, valor) => this.editar('Datos persona', campo, valor)}
          datos={datos['Datos persona']}
        />
        <Alergia
          show={datos['Intención de vacunación'].intencion}
          editar={(campo, valor) => this.editar('Alergia', campo, valor)}
          datos={datos['Alergia']}
        />
        <Sospechoso
          show={datos['Intención de vacunación'].intencion && !datos['Alergia'].alergia}
          editar={(campo, valor) => this.editar('Sospechoso COVID', campo, valor)}
          datos={datos['Sospechoso COVID']}
        />
        <Enfermo
          show={
            datos['Intención de vacunación'].intencion && !datos['Alergia'].alergia &&
            !datos['Sospechoso COVID'].sospechoso
          }
          editar={(campo, valor) => this.editar('Enfermo COVID', campo, valor)}
          datos={datos['Enfermo COVID']}
        />
        <Aislado
          show={
            datos['Intención de vacunación'].intencion && !datos['Alergia'].alergia &&
            !datos['Sospechoso COVID'].sospechoso && !datos['Enfermo COVID'].enfermo
          }
          editar={(campo, valor) => this.editar('Aislado', campo, valor)}
          datos={datos['Aislado']}
        />
        <Convive
          show={true}
          editar={(campo, valor) => this.editar('Convive', campo, valor)}
          datos={datos['Convive']}
        />
        <Observaciones
          show={true}
          editar={(campo, valor) => this.editar('Observaciones', campo, valor)}
          datos={datos['Observaciones']}
        />
      </BaseModal>
    );
  }
}

export default Modal;
